import { EMethod } from './lianlian-manage';

export const yibaoMethod = {
  [EMethod.recharge]: '结算',
  [EMethod.cash]: '提现',
  [EMethod.split]: '分账',
  [EMethod.refound]: '分账退款',
};

/** 易宝交易方式 */ // 收支类型和交易方向是一样的
export enum EYibaoTradingDirection {
  /** 支出 */
  expenditure = 1,
  /** 收入 */
  income = 0,

}

export const yibaoTradingDirection = {
  [EYibaoTradingDirection.expenditure]: '支出',
  [EYibaoTradingDirection.income]: '收入',
};

export interface IYibaoAccountBank {
  /** 银行账户类型 */
  bankAccountType: string;
  /** 开户名称	 */
  bankAccountName: string;
  /** 银行账户号码	 */
  bankCardNo: string;
  /** 开户总行编码	 */
  bankCode: string;
  /** 开户行省编码	 */
  bankProvinceCode: string;
  /** 开户行市编码	 */
  bankCityCode: string;
  /** 联行号	 */
  cnapsCode: string;
  /** 联行名称	 */
  bankBranch: string;
  /**  */
  status: string;
}

export interface IBindNewBankAccountParams {
  id: number;
  /** 银行账户类型 */
  bankAccountType: string;
  /** 开户名称	 */
  bankAccountName: string;
  /** 银行账户号码	 */
  bankCardNo: string;
  /** 开户总行编码	 */
  bankCode: string;
  /** 开户行省编码	 */
  bankProvinceCode: string;
  /** 开户行市编码	 */
  bankCityCode: string;
  /** 联行号	 */
  cnapsCode: string;
  /** 联行名称	 */
  bankBranch: string;
  /** 是否自定义支行信息 */
  customStatus: string;
  /** 是否自定义支行信息 */
  payPassword: string;
}

/** 绑定状态 */
export enum EYibaoBindStatus {
  /** 绑定中 */
  BINDING = 'BINDING',
  /** 已绑定 */
  BOUND = 'BOUND',
  /** 未绑定 */
  UNBOUND = 'UNBOUND',
}

export const yibaoBindStatus = {
  [EYibaoBindStatus.BINDING]: '绑定中',
  [EYibaoBindStatus.BOUND]: '已绑定',
  [EYibaoBindStatus.UNBOUND]: '未绑定',
};

export const yibaoBindStatusStyle = {
  [EYibaoBindStatus.BINDING]: 'primary',
  [EYibaoBindStatus.BOUND]: 'success',
  [EYibaoBindStatus.UNBOUND]: 'info',
};

/** 易宝提现状态 */
export enum EYibaoWithdrawalStatus {
  /** 请求已接收（易宝正在处理中，收到最终结果前请勿重复下单） */
  REQUEST_RECEIVE = 'REQUEST_RECEIVE',
  /** 请求已受理（易宝正在处理中，收到最终结果前请勿重复下单） */
  REQUEST_ACCEPT = 'REQUEST_ACCEPT',
  /** 已到账 */
  SUCCESS = 'SUCCESS',
  /** 失败（该笔订单付款失败,可重新发起付款） */
  FAIL = 'FAIL',
  /** 银行处理中（银行正在处理中，收到最终结果前请勿重复下单） */
  REMITING = 'REMITING',
}

export const yibaoWithdrawalStatusLabel = {
  [EYibaoWithdrawalStatus.REQUEST_RECEIVE]: '已接收',
  [EYibaoWithdrawalStatus.REQUEST_ACCEPT]: '已受理',
  [EYibaoWithdrawalStatus.SUCCESS]: '已到账',
  [EYibaoWithdrawalStatus.FAIL]: '失败',
  [EYibaoWithdrawalStatus.REMITING]: '处理中',
};

export const yibaoWithdrawalStatusStyle = {
  [EYibaoWithdrawalStatus.REQUEST_RECEIVE]: 'primary',
  [EYibaoWithdrawalStatus.REQUEST_ACCEPT]: 'primary',
  [EYibaoWithdrawalStatus.SUCCESS]: 'success',
  [EYibaoWithdrawalStatus.FAIL]: 'danger',
  [EYibaoWithdrawalStatus.REMITING]: 'primary',
};

export interface ITransactionRecordParams {
  page: number;
  size: number;
  /** 商户主键 */
  merchantId: number;
  /** 订单号 */
  orderNo?: string;
  /** 订单号（支付平台） */
  tpOrderNo?: string;
  /** 付款方 */
  payer?: string;
  /** 收款方 */
  payee?: string;
  /** 交易类型 */
  txnType?: EYibaoTxnType;
  /** 交易方向 */
  txnDir?: EYibaoTxnDir;
  /** 账户类型 */
  acctType?: EYibaoAcctType;
  /** 交易时间开始 */
  txnTimeStart?: string;
  /** 交易时间结束 */
  txnTimeEnd?: string;
}

export interface ITransactionRecord {
  /** 商户主键 */
  id: number;
  /** 订单号 */
  orderNo: string;
  /** 订单号（支付平台） */
  tpOrderNo: string;
  /** 付款方 */
  payer: string;
  /** 收款方 */
  payee: string;
  /** 交易类型 */
  txnType: EYibaoTxnType;
  /** 交易方向 */
  txnDir: EYibaoTxnDir;
  /** 账户类型 */
  acctType: EYibaoAcctType;
  /** 初期金额	 */
  initAmt: number;
  /** 交易金额 */
  txnAmt: number;
  /** 末期金额	 */
  finalAmt: number;
  /** 交易时间 */
  txnTime: string;
  /** 交易回单地址 */
  txnRcptUrl: string;
}

/** 易宝交易类型 */
export enum EYibaoTxnType {
  /** 结算 */
  SETTLE = 'SETTLE',
  /** 分账付款（代付） */
  SPLIT_PAY = 'SPLIT_PAY',
  /** 自留 */
  SELF_KEEP = 'SELF_KEEP',
  /** 退款 */
  REFUND = 'REFUND',
  /** 提现 */
  WITHDRAW = 'WITHDRAW',
  /** 结算退款 */
  SETTLE_REFUND = 'SETTLE_REFUND',
  /** 冲退 */
  REVERSAL = 'REVERSAL',
  /** 转账 */
  TRANSFER = 'TRANSFER'
}

export const yibaoTxnTypeConfig = {
  [EYibaoTxnType.SETTLE]: '结算',
  [EYibaoTxnType.SPLIT_PAY]: '代付',
  [EYibaoTxnType.SELF_KEEP]: '自留',
  [EYibaoTxnType.REFUND]: '退款',
  [EYibaoTxnType.WITHDRAW]: '提现',
  [EYibaoTxnType.SETTLE_REFUND]: '结算退款',
  [EYibaoTxnType.REVERSAL]: '冲退',
  [EYibaoTxnType.TRANSFER]: '转账',
};

/** 易宝交易方向 */
export enum EYibaoTxnDir {
  /** 收入 */
  IN = 'IN',
  /** 支出 */
  OUT = 'OUT',
}

export const yibaoTxnDirConfig = {
  [EYibaoTxnDir.IN]: '收入',
  [EYibaoTxnDir.OUT]: '支出',
};

/** 易宝账户类型 */
export enum EYibaoAcctType {
  /** 待分账账户 */
  SPLIT = 'SPLIT',
  /** 余额账户 */
  BALANCE = 'BALANCE',
}

export const yibaoAcctTypeConfig = {
  [EYibaoAcctType.SPLIT]: '待分账账户',
  [EYibaoAcctType.BALANCE]: '余额账户',
};
